import { createApi } from "@mattfinkel/common-web";
import { auth } from "../firebase";

// One client for the app, built from the shared implementation. The members
// are re-exported individually so every existing call site keeps importing
// `authedFetch` / `postJson` / ... from "../lib/api" exactly as before -- the
// package move is invisible above this file.
export const api = createApi({
  auth,
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  // This app's writes land in Google Sheets, and a 503 is the one failure a
  // user can act on ("try again in a minute"), so it gets named rather than
  // reported as a bare status code.
  serviceUnavailableMessage: "Google Sheets is unavailable right now, so that did not save.",
});

export const { warmApi, authedFetch, authedFetchRaw, postJson, putJson } = api;
